import Vue from 'vue';
import VueI18n from 'vue-i18n';
import pt from '../i18n/pt';
import es from '../i18n/es';
import { PT_BR } from '../utils/consts';

Vue.use(VueI18n);

export default new VueI18n({
	locale: PT_BR,
	messages: {
        pt,
        es
	},
});
